import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Outlet } from 'react-router-dom'
import FormPresonals from './form-personal'
import BtnBack from '../../btn-back'
import NavTitle from '../../nav-title'
import { pdfMake } from '../../../lib/pdf-make'
import CardCustom from '../../custom/card-custom'
export default function CheckListDetail({ to, title }) {
  function printPDF() {
    var docDefinition = {
      images: {
        logo: `${window.location.origin}/image/SKY.png`
      },
      header: function (cp, pc, ps) {
        //add logic
        return {
          columns: [
            {
              image: 'logo',
              width: 60,
              alignment: 'left',
              margin: [35, 10, 10, 0]
            },

            {
              text: 'MM00000',
              bold: true,
              alignment: 'right',
              margin: [10, 10, 35, 0]
            }
          ]
        }
      },

      content: [{ text: 'สร้าง PDF ภาษาไทยด้วย pdfmake', fontSize: 15 }],
      defaultStyle: {
        fontSize: 10,
        bold: false,
        font: 'THSarabunNew'
      }
    }
    pdfMake.createPdf(docDefinition).open()
  }
  return (
    <Row>
      <NavTitle>
        <BtnBack text={title} className={'text-muted'} to={to} />
      </NavTitle>
      <Col xl={12}>
        <div>
          <div>
            <CardCustom minHeight="">
              <div className="d-flex">
                <div
                  className="overflow-auto"
                  style={{
                    height: 'calc(100vh - 70px',
                    minWidth: '318px',
                    maxWidth: '318px'
                  }}
                >
                  <div className="p-3">
                    <FormPresonals />
                  </div>
                </div>

                <div
                  className="overflow-auto"
                  style={{
                    height: 'calc(100vh - 70px'
                  }}
                >
                  <div className="p-3">
                    <Outlet />
                  </div>
                </div>
              </div>
            </CardCustom>
          </div>
        </div>
      </Col>
    </Row>
  )
}
